export default {
  "content": "<path d=\"M10.992 7.24a3.75 3.75 0 011.035 6.036l-3.75 3.75a3.75 3.75 0 01-5.304-5.303l1.464-1.464m11.125-.518l1.465-1.464a3.75 3.75 0 00-5.304-5.304l-3.75 3.75a3.75 3.75 0 001.035 6.037\" stroke=\"#161451\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "20",
    "height": "20",
    "viewBox": "0 0 20 20",
    "fill": "none"
  }
};